import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { CertificationsFragmentGql } from './DataQualityCertificationFragmentsGql';
import { DatabaseFragmentGql } from './DatabaseFragmentGql';

export const DatabaseQueryGql: DocumentNode = gql`
query DatabaseQuery($databaseId: ID!, $publishedConnectionsLineageEnabled: Boolean!) {
  databases(filter: { id: $databaseId }, permissionMode: FILTER_RESULTS) {
    ...DatabaseFragment
    tags {
      name
    }
    ...CertificationsFragment
  }
}
${CertificationsFragmentGql}
${DatabaseFragmentGql}
`;

export const DatabaseWithCertificationsQueryGql: DocumentNode = gql`
query DatabaseQueryWithCertifications($databaseId: ID!, $publishedConnectionsLineageEnabled: Boolean!) {
  databases(filter: { id: $databaseId }, permissionMode: FILTER_RESULTS) {
    ...DatabaseFragment
    tags {
      name
    }
    ...CertificationsFragment
  }
}
${DatabaseFragmentGql}
${CertificationsFragmentGql}
`;
